import { useNavigate, useLocation } from "react-router-dom";
import { navigateFn } from "../routingHelper";
import * as awsui from "@cloudscape-design/design-tokens";
import { hover } from "@testing-library/user-event/dist/hover";
import styled from 'styled-components';

export const CustomButton = styled.button`
  cursor: pointer;
  height: fit-content;
  padding: 5px 0px 5px 0px;
  width: 100%;
  min-width: 200px;
  border-radius: 2px;
  align-items: center;
  font-weight: normal; 
  font-size: 1.4rem;
  border-width: 0;
  line-height: 35px;
  white-space: nowrap;

  &:disabled {
    color: grey;
    opacity: 0.7;
    cursor: default;
  } 
`


export const InfoButton = ({ url, buttonName }: any) => {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();

  return (
    <CustomButton
      type="button"
      onClick={(event:any) => {
        event.preventDefault()
        navigate(url)
      }}
      onMouseEnter={ (event:any) => {
        event.currentTarget.style.filter = `drop-shadow(1px 1px 3px ${awsui.colorBackgroundButtonPrimaryDefault}) hue-rotate(20deg)`;
      }}
      onMouseLeave={ (event:any) => {
        event.currentTarget.style.filter = "none";
      }}
      style={{
        background: awsui.colorBackgroundButtonPrimaryDefault,
        color: awsui.colorTextButtonPrimaryDefault,
      }}
    >
     {buttonName}
    </CustomButton>
  )
}


export const PrimaryButton = ({ url, buttonName }: any) => {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();

  return (
    <CustomButton
      type="button"
      onClick={(event:any) => {
        event.preventDefault()
        navigate(url)
      }}
      onMouseEnter={ (event:any) => {
        event.currentTarget.style.filter = `drop-shadow(1px 1px 3px ${awsui.colorBackgroundButtonPrimaryActive}) hue-rotate(20deg)`;
      }}
      onMouseLeave={ (event:any) => {
        event.currentTarget.style.filter = "none";
      }}
      style={{
        background: awsui.colorBackgroundButtonPrimaryActive,
        color: awsui.colorTextButtonPrimaryActive,
      }}
    >
     {buttonName}
    </CustomButton>
  )
}


export const SecondaryButton = ({ url, buttonName, buttonColor, textColor }: any) => {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();

  return (
    <CustomButton
      type="button"
      onClick={(event:any) => {
        event.preventDefault()
        navigate(url)
      }}
      onMouseEnter={ (event:any) => {
        event.currentTarget.style.filter = `drop-shadow(1px 1px 3px ${awsui.colorBackgroundButtonNormalActive}) hue-rotate(20deg)`;
      }}
      onMouseLeave={ (event:any) => {
        event.currentTarget.style.filter = "none";
      }}
      style={{
        background: awsui.colorBackgroundButtonNormalActive,
        color: awsui.colorTextButtonNormalActive,
      }}
    >
     {buttonName}
    </CustomButton>
  )
}

export const WarningButton = ({ url, buttonName, buttonColor, textColor }: any) => {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();

  return (
    <CustomButton
      type="button"
      onClick={(event:any) => {
        event.preventDefault()
        navigate(url)
      }}
      onMouseEnter={ (event:any) => {
        event.currentTarget.style.filter = `drop-shadow(1px 1px 3px ${awsui.colorBackgroundNotificationRed}) hue-rotate(345deg)`;
      }}
      onMouseLeave={ (event:any) => {
        event.currentTarget.style.filter = "none";
      }}
      style={{
        background: awsui.colorBackgroundNotificationRed,
        color: awsui.colorTextNotificationDefault,
      }}
    >
     {buttonName}
    </CustomButton>
  )
}